import React from 'react';
import {useTranslation} from 'react-i18next';
import './satta-card.css';
import GameContainer from './game-container';
import {MatkaListItem} from '@/pages/home/home.type';
import {goTo, useResponsiveDimensions} from '@utils';
import globalStore from '@services/global.state';

const sattaCardBgStyle = {
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 100%',
};

function getResultNum(
  openResultNum?: string | null,
  closeResultNum?: string | null,
) {
  let openNum, closeNum;
  if (openResultNum) {
    openNum = openResultNum.split('').reduce((s, y) => (s + +y) % 10, 0);
  } else {
    openNum = '*';
  }
  if (closeResultNum) {
    closeNum = closeResultNum.split('').reduce((s, y) => (s + +y) % 10, 0);
  } else {
    closeNum = '*';
  }
  return {openNum, closeNum};
}

const SattaCard = ({v}: {i: number; v: MatkaListItem}) => {
  const {t} = useTranslation();
  const {openNum, closeNum} = getResultNum(v.openResultNum, v.closeResultNum);
  const {width} = useResponsiveDimensions();
  return (
    <GameContainer
      onClick={() => {
        goTo('GameSatta', {
          id: v.id,
          lotteryName: v.lotteryName,
        });
        globalStore.updateAmount.next({gameType: 'Matka'});
      }}
      closed={v.isClose === 2}
      gameName={v.lotteryName}>
      <div
        className="h-[5.75rem] rounded-xl flex flex-col justify-between p-2"
        style={{
          width: `calc((${width}px - 2.5rem) / 3)`,
          ...sattaCardBgStyle,
          backgroundImage: `url(${v.backImg})`,
        }}>
        <p className="text-xs font-black text-white satta-game-name">
          {v.lotteryName}
        </p>
        <div className="flex justify-center items-center satta-draw">
          <p className="din font-bold text-sm">
            {v.openResultNum || '***'}-{openNum}
            {closeNum}-{v.closeResultNum || '***'}
          </p>
        </div>
        <div className="flex flex-row justify-between items-center">
          <div>
            <p className="text-10 text-white opacity-60">
              {t('home:label.open')}
            </p>
            <p className="text-8 font-bold text-white">{v.openDraw}</p>
          </div>
          <div>
            <p className="text-10 text-white opacity-60">
              {t('home:label.close')}
            </p>
            <p className="text-8 font-bold text-white">{v.closeDraw}</p>
          </div>
        </div>
      </div>
    </GameContainer>
  );
};

export default SattaCard;
